import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import format from '@/common/utilities/format.js';

export default {
    name: 'propertyTaxHistory',
    components: {
        mvtCollapse,
    },
    props: ['disableCollapse', 'isActive'],
    computed: {
        ...mapGetters('dpp', ['dpp', 'getTaxHistory']),
        description() {
            var latest = this.taxHistoryData && this.taxHistoryData[0];
            if (latest && latest.taxAmount !== '—') {
                return `${latest.taxAmount} property tax in ${latest.year}${latest.taxChange ? ` (${latest.taxChange})` : ''}`;
            }
            return '';
        },
        taxHistoryData() {
            if (!this.getTaxHistory || !this.getTaxHistory.length) {
                return [];
            }
            return this.getTaxHistory.map((item) => ({
                key: item.history_id != null ? item.history_id : item.tax_year,
                year: item.tax_year,
                taxAmount: format.formatPrice(item.tax_amt),
                taxChange: this.formatChange(item.appreciation),
                assessedValue: format.formatPrice(item.total_assessed_value),
                assessedChange: this.formatChange(item.total_assessed_value_change_pct),
            }));
        },
    },
    methods: {
        formatChange(change) {
            var value = parseFloat(change);
            if (!value) {
                return '';
            }
            return value > 0 && !/^\+/.test(change) ? `+${change}` : change;
        },
        getChangeClass(change) {
            var value = parseFloat(change);
            if (!value) {
                return '';
            }
            return value > 0 ? 'text-green' : 'text-red';
        },
    },
};
